"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _color = _interopRequireDefault(require("color"));

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

//calculate action overlay positon.
var NAVIGATION_WIDTH = 200;
var NewDialog = (0, _withStyles["default"])({
  paperFullScreen: {
    backgroundColor: 'transparent'
  },
  // force to lower the attachmentbox
  root: {
    zIndex: '1299 !important'
  }
})(_Dialog["default"]);
var NewBackdrop = (0, _withStyles["default"])(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      backgroundColor: (0, _color["default"])(palette.secondary.main).alpha(0.95).string(),
      backdropFilter: 'blur(3px)'
    }
  };
})(_Backdrop["default"]);

var DetailModal = function DetailModal(_ref2) {
  var isOpen = _ref2.isOpen,
      hideModal = _ref2.hideModal,
      children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$autoHide = _ref2.autoHide,
      autoHide = _ref2$autoHide === void 0 ? true : _ref2$autoHide,
      _ref2$actions = _ref2.actions,
      actions = _ref2$actions === void 0 ? [] : _ref2$actions,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["isOpen", "hideModal", "children", "className", "autoHide", "actions"]);
  return /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    only: "sm"
  }, /*#__PURE__*/_react["default"].createElement(NewDialog, {
    BackdropComponent: NewBackdrop,
    fullScreen: true,
    disableBackdropClick: true,
    open: isOpen,
    onClose: hideModal
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-transparent flex-shrink-0 flex flex-col items-center pt-6",
    style: {
      width: NAVIGATION_WIDTH
    },
    onClick: function onClick(e) {
      return autoHide && hideModal(e, 'backdropClick');
    }
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: "Back"
  }, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
    component: "div",
    disableRipple: true,
    className: "shadow",
    onClick: function onClick(e) {
      e.stopPropagation();
      hideModal(e, 'arrowBackClick');
    },
    disableFocusRipple: true
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null))), actions.map(function (_ref3, index) {
    var icon = _ref3.icon,
        title = _ref3.title,
        _onClick = _ref3.onClick;
    return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      title: title,
      key: title
    }, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
      component: "div",
      disableRipple: true,
      disableFocusRipple: true,
      className: "shadow !mt-6",
      onClick: function onClick(e) {
        e.stopPropagation();

        _onClick(e);
      }
    }, icon));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "shadow-lg overflow-auto flex-1 bg-app"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: 1000
    }
  }, " ", children)))));
};

var _default = DetailModal;
exports["default"] = _default;
//# sourceMappingURL=index.js.map